<div class="max-w-3xl mx-auto px-4 py-16">
  <h1 class="text-3xl font-bold text-gray-900 dark:text-white mb-2">Guides pratiques</h1>
  <p class="text-gray-500 dark:text-gray-400 mb-10">
    Tout pour bien démarrer et exploiter Predivent au maximum.
  </p>
  <div class="space-y-4">
    @for (guide of guides; track guide.title) {
      <div
        class="flex items-start gap-4 p-4 border border-gray-100 dark:border-slate-700 rounded-xl hover:border-purple-200 dark:border-purple-800 transition cursor-not-allowed opacity-70"
      >
        <span class="text-2xl">{{ guide.emoji }}</span>
        <div>
          <h2 class="font-semibold text-gray-900 dark:text-white text-sm">{{ guide.title }}</h2>
          <p class="text-xs text-gray-500 dark:text-gray-400 mt-0.5">{{ guide.desc }}</p>
          <span class="text-xs text-gray-300 mt-1 inline-block"
            >Bientôt disponible</span
          >
        </div>
      </div>
    }
  </div>
</div>
